/**This component section is displayed on main page in Organisation as well as Personal Fundraising */

import { Component, OnInit } from '@angular/core';
import { FlexModule } from '@angular/flex-layout/flex';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-features-and-why-whydonate',
    templateUrl: './features-and-why-whydonate.component.html',
    styleUrls: ['./features-and-why-whydonate.component.scss'],
    standalone: true,
    imports: [NgClass, ExtendedModule, FlexModule, MatCardModule]
})
/** *Features And Why Whydonate Component */
export class FeaturesAndWhyWhydonateComponent implements OnInit {
	constructor() {}
	ngOnInit(): void {}
}
